import React from 'react';

const Footer = (props) => {
  return (
    <footer class='bg-white mt-8 pb-4'>
      <div className='max-w-7xl sm:max-w-md'>
        <div>
          <p className='text-xs text-left text-gray-400'>
            Office: (416) 483-4337{' '}
          </p>
          <p className='text-xs text-left text-gray-400'>
            Orit: (647) 236-1141{' '}
          </p>
          <p className='text-xs text-left text-gray-400'>
            Email: info@smartinvestment.ca{' '}
          </p>
          <p className='text-xs text-left text-gray-400'>
            www.smartinvestment.ca
          </p>
          <p className='text-xs text-left text-gray-400 mb-3'>
            435 Eglinton Ave W, Toronto
          </p>
        </div>
        <p className='text-xs text-left text-gray-400'>
          &copy; {new Date().getFullYear()} Smart Investment. All rights
          reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
